import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, Paper } from '@mui/material';
import FinancialProductDetailsInsurersTableHead from './FinancialProductInsurersTableHead';
import FinancialProductDetailsInsurersTableBody from './FinancialProductInsurersTableBody';
import { get } from '@totalsoft/change-tracking-react';

const FinancialProductDetailsInsurersTable = ({ 
  canWrite, 
  isNewFinancialProduct,
  onAdd,
  onCancelEdit,
  onDelete,
  onSave,
  productInsurerList,  
  insurersList,
  insuranceTypeList,
  conventionList,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <FinancialProductDetailsInsurersTableHead canWrite={canWrite} isNewFinancialProduct={isNewFinancialProduct} onAdd={onAdd} />
          {isNewFinancialProduct && (
            <FinancialProductDetailsInsurersTableBody
              canWrite={canWrite}
              productInsurerList={productInsurerList}
              onCancelEdit={onCancelEdit}
              onDelete={onDelete}
              onSave={onSave}
              insurersList={insurersList}
              insuranceTypeList={insuranceTypeList}
              conventionList={conventionList}
              validation={validation}
            />
          )}
        </Table>
      </TableContainer>
      {!isNewFinancialProduct && <Placeholder message={t('FinancialProduct.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isNewFinancialProduct && (productInsurerList?.length |> get) === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductDetailsInsurersTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isNewFinancialProduct: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  productInsurerList: PropTypes.array.isRequired,
  insurersList: PropTypes.array.isRequired,
  insuranceTypeList: PropTypes.array.isRequired,
  conventionList: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductDetailsInsurersTable;
